import axiosInstance from "../utils/axios";
import FormData from "form-data";

export const getBooks = async (
  page,
  size,
  sortValue,
  sortType,
  searchCol,
  searchText,
  fromDate,
  toDate
) => {
  try {
    const res = await axiosInstance.get("api/book/search", {
      params: {
        fromDate: fromDate,
        toDate: toDate,
        page: page,
        size: size,
        sortBy: sortValue,
        orderBy: sortType,
        searchKey: searchCol,
        searchValue: searchText,
      },
      withCredentials: true,
    });

    return res.data;
  } catch (error) {
    return error;
  }
};

export const exportBooks = async (searchCol, searchText, fromDate, toDate) => {
  try {
    const res = await axiosInstance.post(
      "api/book/export",
      {
        headers: {
          accept: "text/csv",
        },
        withCredentials: true,
      },
      {
        params: {
          fromDate: fromDate,
          toDate: toDate,
          searchKey: searchCol,
          searchValue: searchText,
        },
      }
    );

    return res.data;
  } catch (error) {
    return error;
  }
};
export const getBook = async (id) => {
  const res = await axiosInstance.get(`/api/book/${id}`, {
    withCredentials: true,
  });
  return res;
};

export const singleBookUpload = async (book, file, cover) => {
  const formDataFiles = new FormData();
  formDataFiles.append("book", JSON.stringify(book));
  formDataFiles.append("file", file);
  formDataFiles.append("cover", cover);

  const res = await axiosInstance.post(`api/book/singleUpload`, formDataFiles, {
    headers: formDataFiles.getHeaders,
    withCredentials: true,
  });
  return res;
};

export const createBook = async (data) => {
  const res = await axiosInstance.post("api/book", data);
  return res;
};

export const uploadBookFile = async (id, file) => {
  const formData = new FormData();
  formData.append("file", file);

  const res = await axiosInstance.post(`api/book/${id}/file`, formData, {
    headers: formData.getHeaders,
  });
  return res;
};

export const uploadBulkBooks = async (data) => {
  const formData = new FormData();
  formData.append("zipFile", data?.file?.[0]);
  const res = await axiosInstance.post(`api/book/batch`, formData, {
    headers: formData.getHeaders,
    withCredentials: true,
  });
  return res;
};

export const uploadBookCoverFile = async (id, file) => {
  const formData = new FormData();
  formData.append("file", file);

  const res = await axiosInstance.post(`api/book/${id}/cover`, formData, {
    headers: formData.getHeaders,
  });
  return res;
};

export const uploadBook = async (id, distributors) => {
  const res = await axiosInstance.put(`api/book/${id}/upload`, distributors, {
    withCredentials: true,
  });
  return res;
};

export const updateBook = async (id, data) => {
  const res = await axiosInstance.put(`api/book/${id}`, data, {
    withCredentials: true,
  });
  return res;
};

export const downloadAcsm = async (id) => {
  const res = await axiosInstance.get(`api/book/acsm/${id}`, {
    withCredentials: true,
  });
  return res;
};

export const deleteBook = async (id) => {
  const res = await axiosInstance.delete(`/api/book/delete/${id}`, {
    withCredentials: true,
  });
  return res;
};
